import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

@doc.path('/plan_analyses/{id}/match-preview')
export default class PlanAnalysisMatchPreviewModel extends MapServiceModel {
}
